/**
 * Session storage utilities
 * Handles persisting and retrieving auth data from localStorage
 */

import type { AuthData } from './authTypes';

const STORAGE_KEY = 'littlebooker_auth';

export function saveAuthData(authData: AuthData): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(authData));
}

export function loadAuthData(): AuthData | null {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (!stored) {
    return null;
  }

  try {
    return JSON.parse(stored) as AuthData;
  } catch {
    console.error('Failed to parse stored auth data');
    return null;
  }
}

export function clearAuthData(): void {
  localStorage.removeItem(STORAGE_KEY);
}
